<template>
<v-app>
    <div class="page_thankyoutakeout">

        <v-container>
            <v-row class="justify-center">
                <v-col cols="11" sm="10" md="11" lg="5" xl="6">
                    <div class="text-center title_size_thankyoutakeout">เราได้รับออเดอร์ของคุณแล้ว</div>
                    <div class="img_thankyoutakeout ">
                        <img :src="beforeImage">
                    </div>
                    <div class="text-center titleshort_size_thankyoutakeout">กรุณารออาหารสักครู่</div>
                    <!-- <div class="text-center titleshort_size_thankyoutakeout">กรุณารอ 10-20 นาทีค่ะ</div> -->
                    <div class="text-center title_thankyoutakeout mb-3">ขอบคุณที่ให้เราเป็นส่วนหนึ่งของมื้ออาหารแสนอร่อย</div>
                    <div class="text-center">
                        <v-btn rounded width="100%" height="65" class="white--text" :style="{background: bg_color}" @click="$router.push('/nametakeoutuser')">กดเพื่อสั่งอาหาร</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-container>

    </div>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/new_logologinandtkfull.png";
export default {
    name: 'thankYouTakeOut',
    data() {
        return {
            beforeImage: before_image,
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
        }
    },
    methods: {
        async colorRestaurant() {
            HTTP.get(`/showColor?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token)
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.beforeImage = response.data.logo_image
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/nametakeoutuser')
                    }

                })
        },
    },
    created() {
        this.$store.commit('clearCartListUser')
        this.$store.commit('clearCartTakeOutTableListUser')
        this.$store.commit('clearCartListUserTakeOut')
        this.$store.commit('clearCartOrderOnlineUser')
    },
    mounted() {
        this.colorRestaurant()
        setTimeout(() => this.$router.push('/nametakeoutuser'), 5000)
    },
}
</script>

<style scoped>
.page_thankyoutakeout {
    /* background-color: #fdbd10; */
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.color_btn {
    background: linear-gradient(to top, #038cc1, #55c0e9);
}

.img_thankyoutakeout {
    width: 300px;
    margin: auto;
}

.img_thankyoutakeout>img {
    max-width: 100%;
}

.title_size_thankyoutakeout {
    font-size: 34px;
}

.titleshort_size_thankyoutakeout {
    font-size: 36px;
}

.title_thankyoutakeout {
    font-size: 26px;
    /* color: #fff; */
}
</style>
